"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const sub_layout_1 = require("../../../../layouts/sub-layout");
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../actions/actions");
const themes_1 = require("../../../../utils/themes");
const data_transformation_step1_1 = require("../subSteps/dataTransformation/data-transformation-step1");
const data_transformation_step2_1 = require("../subSteps/dataTransformation/data-transformation-step2");
const data_transformation_step3_1 = require("../subSteps/dataTransformation/data-transformation-step3");
const data_transformation_step4_1 = require("../subSteps/dataTransformation/data-transformation-step4");
const data_transformation_rca_ms_step1_1 = require("../subSteps/dataTransformation/data-transformation-rca-ms-step1");
const data_transformation_rca_ms_step2_1 = require("../subSteps/dataTransformation/data-transformation-rca-ms-step2");
const react_spinners_1 = require("react-spinners");
const api_1 = require("../../../../utils/api");
const data_transformation_step2Anomaly_1 = require("../subSteps/dataTransformation/data-transformation-step2Anomaly");
const style_1 = tslib_1.__importDefault(require("../../../../utils/style"));
const environment_1 = require("src/environments/environment");
const Utils_1 = require("../../../../utils/Utils");
const Icons_1 = require("../../../../../../components/Icons");
const js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
function DataTransformation(props) {
    const dispatch = react_redux_1.useDispatch();
    const mainStep = react_redux_1.useSelector((state) => state.mainStep.no);
    const projectInfo = react_redux_1.useSelector((state) => state.ProjectInfo);
    const [snackbarOpen, setSnackbarOpen] = react_1.useState(false);
    const [snackbarMessage, setSnackbarMessage] = react_1.useState("");
    const [snackbarType, setSnackbarType] = react_1.useState("");
    const mounted = react_1.useRef(true);
    const styleLocal = style_1.default();
    react_1.useEffect(() => {
        setSubStepData(subSteppers[projectInfo.problemtype]);
        console.log("projectInfo", projectInfo);
        return () => {
            mounted.current = false;
        };
    }, [projectInfo]);
    react_1.useEffect(() => {
        let isMounted = true;
        localStorage.setItem('pageFlag', 3);
        return () => {
            isMounted = false;
        };
    }, []);
    const [featureSelectionData, setFeatureSelectionData] = react_1.useState([]);
    const [encodingSelectionData, setEncodingSelectionData] = react_1.useState([]);
    const [samplingMethod, setSamplingMethod] = react_1.useState("oversampling");
    const [trainTestRatio, setTrainTestRatio] = react_1.useState(0);
    const [isVisualizeButton, setIsVisualizeButton] = react_1.useState(false);
    const [isVisualizeTable, setIsVisualizeTable] = react_1.useState(false);
    const [isVisualizationFinal, setIsVisualizationFinal] = react_1.useState(false);
    const [currentStep, setCurrentStep] = react_1.useState(0);
    const [loading, setLoading] = react_1.useState(false);
    const [visualizationTable, setVisualizationTable] = react_1.useState([]);
    const [subStepperData, setSubStepData] = react_1.useState(null);
    const errorInitial = {
        featureColumnsError: "",
        targetColumnsError: "",
        encodingError: "",
        normalizationError: "",
        trainTestSplitError: "",
        trainTestSplitInvalidError: "",
        dataTransFormAlgorithm: "",
        dataTransFormEventColumn: "",
        leafNodeError: "",
        forbidsError: "",
        requiresError: "",
        fileError: ""
    };
    const [transFormData, setTransFormData] = react_1.useState({});
    const [errorMessages, setErrorMessage] = react_1.useState(errorInitial);
    const [graphPath, setGraphPath] = react_1.useState("");
    const [yamlFilePath, setYamlFilePath] = react_1.useState("");
    const subSteppers = {
        regression: [
            { required: true, text: "Feature Selection", active: true },
            { required: true, text: "Encoding", active: false },
            { required: false, text: "Train Test Split", active: false },
        ],
        eventclassification: [
            { required: true, text: "Feature Selection", active: true },
            { required: false, text: "Train Test Split", active: false },
        ],
        RootCauseAnalysis: [
            { required: true, text: "Feature Selection", active: true },
            { required: true, text: "Encoding", active: false },
            { required: false, text: "Train Test Split", active: false },
        ],
        rca_ms: [
            { required: true, text: "Graph Generation", active: true },
            { required: false, text: "Visualize Graph", active: false },
            { required: false, text: "Train Test Split", active: false },
        ],
        anomalydetection: [
            { required: true, text: "Feature Selection", active: true },
            { required: true, text: "Normalization", active: false },
            { required: false, text: "Train Test Split", active: false },
        ],
    };
    const setCurrentStepByClick = (step) => {
        if (step >= 0 && step < subStepperData.length && step <= currentStep) {
            const updatedSubStepperData = subStepperData.map((item, index) => (Object.assign({}, item, { active: index <= step })));
            setSubStepData(updatedSubStepperData);
            setCurrentStep(step);
            setIsVisualizeButton(false);
            setIsVisualizeTable(false);
            setIsVisualizationFinal(false);
        }
    };
    const validateStep = (step) => {
        let newErrors = Object.assign({}, errorMessages);
        let isValid = true;
        switch (step) {
            case 'featureColumns':
                if (featureSelectionData.featurecolumns.length === 0) {
                    newErrors.featureColumnsError = "*Feature Columns are required.";
                    isValid = false;
                }
                if (featureSelectionData.featureSelectionTargetColumns.length === 0) {
                    newErrors.targetColumnsError = "*Feature Columns are required.";
                    isValid = false;
                }
                break;
            // case 'encoding':
            //   if ( encodingSelectionData.selectedLabelEncoding.length === 0 && encodingSelectionData.selectedOnehotEncoding.length === 0) {
            //     newErrors.encodingError = "*Please encode the columns before proceeding.";
            //     isValid = false;
            //   } 
            //   if (encodingSelectionData.selectedMinMaxScaler.length === 0 && encodingSelectionData.selectedStandardScaler.length === 0){
            //     newErrors.normalizationError = "*Please normalize the columns before proceeding.";
            //     isValid = false;
            //   } 
            //   break;
            case 'testSplit':
                const trainTestRatioStr = String(trainTestRatio).trim();
                if (trainTestRatioStr === "" || isNaN(trainTestRatio) || trainTestRatio <= 0 || trainTestRatio >= 100) {
                    newErrors.trainTestSplitError = "*Train test split percentage is required.";
                    newErrors.trainTestSplitInvalidError = "*Train test split percentage is invalid.";
                    isValid = false;
                }
                break;
            case 'rca_ms':
                if (transFormData.algorithm == "") {
                    newErrors.dataTransFormAlgorithm = "Algorithm is required";
                    isValid = false;
                }
                if (transFormData.domain_knowledge_method == "") {
                    newErrors.dataTransFormEventColumn = "Domain knowldge Input method is required";
                    isValid = false;
                }
                if (transFormData.selected_yaml_file == null && transFormData.domain_knowledge_method == "upload_file") {
                    newErrors.fileError = "Please select a file.";
                    isValid = false;
                }
                break;
        }
        setErrorMessage(newErrors);
        return isValid;
    };
    const increaseStep = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        let lastIndex = 0;
        let validationFailed = false;
        subStepperData.forEach((d, i) => {
            if (d.active) {
                lastIndex = i;
            }
        });
        if (lastIndex === 1 && projectInfo.problemtype == "eventclassification") {
            lastIndex += 2;
        }
        if (lastIndex === 2 && (projectInfo.problemtype !== "eventclassification")) {
            lastIndex += 1;
        }
        try {
            if (lastIndex === 0) {
                if (projectInfo.problemtype === "rca_ms") {
                    console.log('transform', transFormData);
                    if (errorMessages.forbidsError != "" || errorMessages.requiresError != "") {
                        setSnackbarOpen(true);
                        setSnackbarMessage(errorMessages.forbidsError || errorMessages.requiresError);
                        setSnackbarType('error');
                        return;
                    }
                    if (!validateStep('rca_ms')) {
                        validationFailed = true;
                        console.error("Empty field error, feature columns.");
                    }
                    else {
                        console.log("step 1 data transformation");
                        const dataTransform = {
                            projectname: projectInfo.projectname,
                            problemtype: projectInfo.problemtype,
                            version_name: projectInfo.version_name,
                            userid: js_cookie_1.default.get('USER_ID'),
                            algorithm: transFormData.algorithm,
                            domain_knowledge_method: transFormData.domain_knowledge_method,
                            domain_knowledge: transFormData.domain_knowledge
                        };
                        console.log(transFormData);
                        dispatch(actions_1.saveDataTransFormRcaMs(transFormData));
                        const response = yield api_1.graphGeneration(dataTransform);
                        console.log(response.data.graph_df_path);
                        if (response.status == 200) {
                            //update path based on ml env 
                            let graphPathRelative;
                            let relative_domaink_path;
                            if (response && response.data && response.data.graph_df_path) {
                                graphPathRelative = Utils_1.getRelativePath(response.data.graph_df_path);
                                setGraphPath(`${environment_1.environment.MLBE}/${graphPathRelative}`);
                                dispatch(actions_1.saveGraphPath(`${environment_1.environment.MLBE}/${graphPathRelative}`));
                            }
                            if (response && response.data.domain_knowledge_filepath) {
                                relative_domaink_path = Utils_1.getRelativePath(response.data.domain_knowledge_filepath);
                                setYamlFilePath(`${environment_1.environment.MLBE}/${relative_domaink_path}`);
                            }
                        }
                    }
                }
                else {
                    if (!validateStep('featureColumns')) {
                        validationFailed = true;
                        console.error("Empty field error, feature columns.");
                    }
                    else {
                        console.log("Feature columns Section");
                        const feature_selection_data = {
                            projectname: projectInfo.projectname,
                            problemtype: projectInfo.problemtype,
                            version_name: projectInfo.version_name,
                            userid: js_cookie_1.default.get('USER_ID'),
                            feature_selection: {
                                featureselection_method: featureSelectionData.featureselection_method,
                                featurecolumns: featureSelectionData.featurecolumns,
                                targetcolumns: featureSelectionData.featureSelectionTargetColumns,
                                datetime_columns: featureSelectionData.featureSelectionDateTimeColumns,
                                threshold: featureSelectionData.threshold,
                                k: featureSelectionData.k,
                            }
                        };
                        dispatch(actions_1.saveFeatureSelections(featureSelectionData));
                        const featureSelectionRes = yield api_1.featureSelection(feature_selection_data);
                        console.log("Feature Selection Response", featureSelectionRes);
                    }
                }
            }
            else if (lastIndex === 1) {
                if (projectInfo.problemtype === "rca_ms") {
                    const graph_confirmation = {
                        projectname: projectInfo.projectname,
                        problemtype: projectInfo.problemtype,
                        version_name: projectInfo.version_name,
                        userid: js_cookie_1.default.get('USER_ID'),
                    };
                    const response = yield api_1.graphConfirmation(graph_confirmation);
                }
                else if (projectInfo.problemtype === "anomalydetection") {
                    const normalizationData = {
                        projectname: projectInfo.projectname,
                        problemtype: projectInfo.problemtype,
                        version_name: projectInfo.version_name,
                        userid: js_cookie_1.default.get('USER_ID'),
                        normalization: {
                            feature_columns: encodingSelectionData.anomalyFeatureColumnOperation,
                            target_columns: encodingSelectionData.anomalyTargetColumnOperation,
                        }
                    };
                    dispatch(actions_1.saveColumnSelectionS32(encodingSelectionData));
                    const normalizationRes = yield api_1.handleNormalization(normalizationData);
                    console.log("Normalization Response", normalizationRes);
                }
                else if (!validateStep('encoding')) {
                    validationFailed = true;
                    console.error("Empty field error, encoding.");
                }
                else {
                    console.log("Encoding Data Section");
                    const encoding_data = {
                        projectname: projectInfo.projectname,
                        problemtype: projectInfo.problemtype,
                        version_name: projectInfo.version_name,
                        userid: js_cookie_1.default.get('USER_ID'),
                        encoding: {
                            categorical: {
                                labelencoding: encodingSelectionData.selectedLabelEncoding,
                                onehotencoding: encodingSelectionData.selectedOnehotEncoding,
                            },
                            numerical: {
                                minmaxscaler: encodingSelectionData.selectedMinMaxScaler,
                                standardscaler: encodingSelectionData.selectedStandardScaler,
                            }
                        }
                    };
                    dispatch(actions_1.saveColumnSelectionS32(encodingSelectionData));
                    const encodingDataRes = yield api_1.handleEncoding(encoding_data);
                    console.log("Encoding Response", encodingDataRes);
                }
            }
            else if (lastIndex === 2) {
                const handling_imbalanced_data = {
                    projectname: projectInfo.projectname,
                    problemtype: projectInfo.problemtype,
                    version_name: projectInfo.version_name,
                    userid: js_cookie_1.default.get('USER_ID'),
                    handlingimbalanceddataset: {
                        samplingmethod: samplingMethod
                    }
                };
                dispatch(actions_1.saveSamplingMethod(samplingMethod));
                const samplingRes = yield api_1.handleImbalanceData(handling_imbalanced_data);
                console.log("Handling Imbalanced Data Response", samplingRes);
            }
            else if (lastIndex === 3) {
                if (!validateStep('testSplit')) {
                    validationFailed = true;
                    console.error("Empty field error, train split.");
                }
                else {
                    console.log("Handling Imbalanced Data");
                    if (isVisualizeButton) {
                        console.log("the end");
                    }
                    else {
                        const train_test_split_data = {
                            projectname: projectInfo.projectname,
                            problemtype: projectInfo.problemtype,
                            version_name: projectInfo.version_name,
                            userid: js_cookie_1.default.get('USER_ID'),
                            traintestsplit: {
                                percentage: trainTestRatio
                            }
                        };
                        dispatch(actions_1.saveTrainTestRatio(trainTestRatio));
                        const traintestsplitRes = yield api_1.handleTrainTestSplit(train_test_split_data);
                        console.log("Train Test Split Response", traintestsplitRes);
                        if (projectInfo.problemtype === "regression") {
                            yield getVisualizationData();
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }
                        setIsVisualizeButton(true);
                    }
                }
            }
            if (!validationFailed) {
                if (lastIndex + 1 < subStepperData.length) {
                    let newSubStep = [...subStepperData];
                    newSubStep[lastIndex + 1].active = true;
                    setSubStepData(newSubStep);
                    lastIndex += 1;
                    if (projectInfo.problemtype === "eventclassification") {
                        lastIndex += 2;
                    }
                    if ((projectInfo.problemtype !== "eventclassification") && lastIndex === 2) {
                        lastIndex += 1;
                    }
                }
                else if (isVisualizeButton || projectInfo.problemtype != "regression") {
                    const data = {
                        algorithm: "",
                        domain_knowledge_method: "",
                        domain_knowledge: {
                            "root-nodes": [],
                            "leaf-nodes": [],
                            forbids: [],
                            requires: []
                        },
                        selected_yaml_file: ""
                    };
                    dispatch(actions_1.saveDataTransFormRcaMs(data));
                    dispatch(actions_1.changeMainStep(mainStep + 1));
                    localStorage.setItem('pageFlag', 4);
                }
            }
        }
        catch (error) {
            console.error("API call failed: ", error);
        }
        finally {
            setCurrentStep(lastIndex);
            if (mounted.current) {
                setLoading(false);
            }
        }
    });
    const decreaseStep = () => {
        setErrorMessage("");
        let lastIndex = 0;
        subStepperData.forEach((d, i) => {
            if (d.active) {
                lastIndex = i;
            }
        });
        if (lastIndex > 0) {
            let newSubStep = [...subStepperData];
            newSubStep[lastIndex].active = false;
            newSubStep[lastIndex - 1].active = true;
            setSubStepData(newSubStep);
            lastIndex -= 1;
        }
        else {
            dispatch(actions_1.changeMainStep(mainStep - 1));
            localStorage.setItem('pageFlag', 2);
        }
        setCurrentStep(lastIndex);
        setIsVisualizeButton(false);
        setIsVisualizeTable(false);
        setErrorMessage(errorInitial);
    };
    const getVisualizationData = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        const visualization_table_data = {
            projectname: projectInfo.projectname,
            problemtype: projectInfo.problemtype,
            version_name: projectInfo.version_name,
            userid: js_cookie_1.default.get('USER_ID'),
        };
        try {
            const visualizationRes = yield api_1.visualizeAfterSplit(visualization_table_data);
            console.log("visualizationRes", visualizationRes.data);
            if (visualizationRes.data.status === "success") {
                console.log("visualizationRes.data.visualization_data", visualizationRes.data.train_data);
                setVisualizationTable(visualizationRes.data.train_data);
            }
        }
        catch (error) {
            console.error("Failed to fetch visualization data: ", error);
        }
        finally {
            setLoading(false);
        }
    });
    const renderVisualizeTable = () => {
        setIsVisualizeTable(true);
        setIsVisualizationFinal(true);
    };
    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };
    return (react_1.default.createElement(core_1.Grid, { container: true },
        loading && (react_1.default.createElement("div", { style: {
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(128, 128, 128, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999
            } },
            react_1.default.createElement(react_spinners_1.PropagateLoader, { color: "#3f51b5" }))),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 3, lg: 3 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 6, lg: 6, style: {
                textAlign: "center",
                paddingTop: "20px",
                paddingBottom: "20px",
            } }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 3, lg: 3 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 3, lg: 3 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 6, lg: 6 }, subStepperData && react_1.default.createElement(sub_layout_1.SubLayout, { data: subStepperData, setCurrentStepByClick: setCurrentStepByClick, currentStep: (projectInfo.problemtype === "eventclassification" && currentStep === 3) ? 1
                : ((projectInfo.problemtype !== "eventclassification") && currentStep === 3) ? 2
                    : currentStep })),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 3, lg: 3 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 8, sm: 8, md: 8, lg: 8 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 3, sm: 3, md: 3, lg: 3 },
            react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'flex-end' } }, isVisualizeButton && !isVisualizationFinal && currentStep === 3 && projectInfo.problemtype === "regression" &&
                react_1.default.createElement(core_1.Button, { variant: "outlined", style: Object.assign({}, themes_1.nextBotton, { width: '50%' }), onClick: () => renderVisualizeTable() }, "Visualization")),
            !isVisualizeButton && !isVisualizationFinal && ((currentStep === 3 && (projectInfo.problemtype === "regression")) || (currentStep === 4 && projectInfo.problemtype === "anomalydetection")) &&
                react_1.default.createElement(core_1.Typography, { className: styleLocal.errorText },
                    react_1.default.createElement(Icons_1.LockIcon, null),
                    "Complete All Steps to Show Visualize Table")),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 1, sm: 1, md: 1, lg: 1 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 12, lg: 12, style: { paddingTop: "30px" } },
            currentStep === 0 && projectInfo.problemtype === "rca_ms" && react_1.default.createElement(data_transformation_rca_ms_step1_1.DataTransformationRCAMSStep1, { setTransFormData: setTransFormData, errorMessages: errorMessages, setErrorMessage: setErrorMessage }),
            currentStep === 0 && projectInfo.problemtype !== "rca_ms" && react_1.default.createElement(data_transformation_step1_1.DataTransformationStep1, { setFeatureSelectionData: setFeatureSelectionData, errorMessages: errorMessages }),
            currentStep === 1 && projectInfo.problemtype !== "anomalydetection" && projectInfo.problemtype !== "rca_ms" && react_1.default.createElement(data_transformation_step2_1.DataTransformationStep2, { setEncodingSelectionData: setEncodingSelectionData, errorMessages: errorMessages }),
            currentStep === 1 && projectInfo.problemtype === "rca_ms" && react_1.default.createElement(data_transformation_rca_ms_step2_1.DataTransformationRCAMSStep2, { graphPath: graphPath, yamlFile: yamlFilePath, method: transFormData.domain_knowledge_method }),
            currentStep === 1 && projectInfo.problemtype === "anomalydetection" && react_1.default.createElement(data_transformation_step2Anomaly_1.DataTransformationStep2Anomaly, { setEncodingSelectionData: setEncodingSelectionData, errorMessages: errorMessages }),
            currentStep === 2 && react_1.default.createElement(data_transformation_step3_1.DataTransformationStep3, { setSamplingMethod: setSamplingMethod }),
            currentStep === 2 && projectInfo.problemtype === "rca_ms" && react_1.default.createElement(data_transformation_step4_1.DataTransformationStep4, { setTrainTestRatio: setTrainTestRatio, isVisualizeTable: isVisualizeTable, visualizationTable: visualizationTable, errorMessages: errorMessages }),
            currentStep === 3 && react_1.default.createElement(data_transformation_step4_1.DataTransformationStep4, { setTrainTestRatio: setTrainTestRatio, isVisualizeTable: isVisualizeTable, visualizationTable: visualizationTable, errorMessages: errorMessages })),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: currentStep === 3 && projectInfo.problemtype === "rca_ms" ? 5 : 6, lg: currentStep === 3 && projectInfo.problemtype === "rca_ms" ? 5 : 6 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 4, lg: 4 },
            react_1.default.createElement("div", { style: { width: "100%", textAlign: "right" } },
                react_1.default.createElement(core_1.Button, { variant: "outlined", style: themes_1.cancelBotton, onClick: decreaseStep }, currentStep === 1 && projectInfo.problemtype === "rca_ms" ? "Regenerate Graph" : "Previous"),
                react_1.default.createElement(core_1.Button, { style: Object.assign({}, themes_1.nextBotton, { backgroundColor: (isVisualizeButton && !isVisualizationFinal) ? 'gray' : themes_1.nextBotton.backgroundColor }), onClick: increaseStep, disabled: (isVisualizeButton && !isVisualizationFinal) }, currentStep === 1 && projectInfo.problemtype === "rca_ms" ?
                    "Proceed" :
                    currentStep === 3 && projectInfo.problemtype === "rca_ms" ? "save"
                        : "Next"))),
        react_1.default.createElement(core_1.Snackbar, { open: snackbarOpen, autoHideDuration: 3000, onClose: handleCloseSnackbar, anchorOrigin: { vertical: "bottom", horizontal: "right" } },
            react_1.default.createElement(lab_1.Alert, { onClose: handleCloseSnackbar, severity: snackbarType, sx: { width: '100%' } }, snackbarMessage))));
}
exports.DataTransformation = DataTransformation;
//# sourceMappingURL=data-transformation.js.map